import _toConsumableArray from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "export-excel"
};
var _hoisted_2 = {
  key: 1,
  class: "contact-UPS"
};
var _hoisted_3 = {
  class: "info"
};
var _hoisted_4 = {
  class: "info-title"
};
var _hoisted_5 = {
  class: "info-popover-container"
};
var _hoisted_6 = {
  class: "info-item"
};
var _hoisted_7 = {
  class: "info-value"
};
var _hoisted_8 = {
  class: "info-item"
};
var _hoisted_9 = {
  class: "info-value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sidebar_item = _resolveComponent("sidebar-item");
  var _component_el_menu = _resolveComponent("el-menu");
  var _component_el_scrollbar = _resolveComponent("el-scrollbar");
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_link = _resolveComponent("el-link");
  var _component_el_popover = _resolveComponent("el-popover");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'has-logo': $options.showLogo
    })
  }, [_createVNode(_component_el_scrollbar, {
    "wrap-class": "scrollbar-wrapper"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_menu, {
        ref: "menu",
        "default-active": $data.defaultActiveMenu,
        "background-color": $options.variables.menuBg,
        "text-color": $options.variables.menuText,
        "unique-opened": true,
        "active-text-color": $options.variables.menuActiveText,
        "collapse-transition": false,
        mode: "vertical",
        onSelect: $options.onMenuSelect
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permission_routes, function (route) {
            return _openBlock(), _createBlock(_component_sidebar_item, {
              key: route.path,
              item: route,
              "base-path": route.path
            }, null, 8, ["item", "base-path"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["default-active", "background-color", "text-color", "active-text-color", "onSelect"])];
    }),
    _: 1
  }), $props.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    class: "export-btn",
    icon: "Download",
    round: "",
    onClick: $options.exportExcel
  }, {
    default: _withCtx(function () {
      return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode(" 导出报表 ", -1)]));
    }),
    _: 1
  }, 8, ["onClick"])])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[12] || (_cache[12] = _createElementVNode("p", null, "如有问题，请联系我们", -1)), _createVNode(_component_el_popover, {
    modelValue: $data.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.visible = $event;
    }),
    "popper-class": "info-popover",
    placement: "right",
    width: "360"
  }, {
    reference: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        round: "",
        class: "btn-contact-UPS"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[11] || (_cache[11] = [_createTextVNode("联系UPS", -1)]));
        }),
        _: 1
      })];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("span", null, "联系方式信息", -1)), _createElementVNode("i", {
        class: "el-icon-close info-title_close",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $data.visible = false;
        })
      })]), _createVNode(_component_el_scrollbar, {
        class: "info-popover-scroll"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_5, [_cache[10] || (_cache[10] = _createElementVNode("dl", {
            class: "info-item"
          }, [_createElementVNode("dt", {
            class: "info-label"
          }, "出口单证")], -1)), _createElementVNode("dl", _hoisted_6, [_cache[6] || (_cache[6] = _createElementVNode("dt", {
            class: "info-label"
          }, "上海口岸：", -1)), _createElementVNode("dd", _hoisted_7, [_cache[5] || (_cache[5] = _createTextVNode("联系邮箱：Jiang Yun Tao ", -1)), _createVNode(_component_el_link, {
            type: "primary",
            href: "mailto:yxjiang@ups.com"
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("yxjiang@ups.com", -1)]));
            }),
            _: 1
          })])]), _createElementVNode("dl", _hoisted_8, [_cache[9] || (_cache[9] = _createElementVNode("dt", {
            class: "info-label"
          }, "郑州口岸：", -1)), _createElementVNode("dd", _hoisted_9, [_cache[8] || (_cache[8] = _createTextVNode("联系邮箱：Li Ping ", -1)), _createVNode(_component_el_link, {
            type: "primary",
            href: "mailto:liperry@ups.com"
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[7] || (_cache[7] = [_createTextVNode("liperry@ups.com", -1)]));
            }),
            _: 1
          })])])])];
        }),
        _: 1
      })])];
    }),
    _: 1
  }, 8, ["modelValue"])]))], 2);
}